/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminOrganiserPotentialDto { 
    /**
     * People who own or administer at least one group
     */
    groupLeaders: number;
    /**
     * Group leaders who never created a single activity. The actionable list: they already organise socially on the platform without ever using the feature that matters.
     */
    groupLeadersNeverOrganised: number;
}

